<template>
  <generic-container
    icon="id card"
    :title="$t('roles')"
    :show_plus="true"
    :searchable="true"
    v-on:add="add"
    v-on:filter="filter"
  >
    <div class="ui very relaxed divided selection list">
      <div
        class="item"
        v-on:click="update(role)"
        v-for="(role, index) in roles"
        v-bind:key="index"
      >
        <div
          class="ui red right floated mini icon button"
          v-on:click.stop="remove(role, index)"
        >
          <i class="trash icon"></i>
        </div>
        <i class="large id card circle middle aligned icon"></i>
        <div class="content">
          <a class="header">{{ role.name }}</a>
          <div class="description">
            {{ role.description }}
          </div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in role_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy_modal"
        :role_id="role_id"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import RoleModal from "./role_modal/Index";
import { local_api, toast, clone } from "@/utils";

export default {
  components: {
    "generic-container": GenericContainer,
  },
  data() {
    return {
      all_roles: [],
      roles: [],
      role_id: undefined,
      role_modals: [],
    };
  },
  methods: {
    add() {
      this.role_id = undefined;
      this.role_modals.push(RoleModal);
    },
    succedded(role) {
      let idx = this.roles.findIndex((n) => n.role_id == role.role_id);
      if (idx >= 0) this.roles.splice(idx, 1, role);
      else this.roles.push(role);
    },
    update(role) {
      this.role_id = role.role_id;
      this.role_modals.push(RoleModal);
    },
    remove(role, index) {
      let vm = this;
      this.$alertify.confirm(
        vm.$i18n.t("are you sure to delete role?"),
        function() {
          vm.processing = true;
          local_api(vm, "post", "/user_role/do-delete", {
            i: role.encrypted_id,
          })
            .then(() => {
              vm.roles.splice(index, 1);
            })
            .catch((err) => {
              toast(vm.$el, "error", err);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
        function() {},
      );
    },
    filter(query) {
      if (query == "") this.roles = clone(this.all_roles);
      else
        this.roles = this.all_roles.filter(
          (n) =>
            n.name.toUpperCase().includes(query.toUpperCase()) ||
            n.description.toUpperCase().includes(query.toUpperCase()),
        );
    },
    destroy_modal() {
      this.role_modals = [];
    },
  },
  mounted() {
    this.processing = true;
    let vm = this;
    local_api(this, "post", "/user_role/do-get-all", {})
      .then((response) => {
        this.all_roles = this.roles = response;
      })
      .catch((err) => {
        toast(vm.$el, "error", err);
      })
      .finally(() => {
        vm.processing = false;
      });
  },
};
</script>
